
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function TailwheelEndorsement() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-teal-600 to-teal-700 text-white py-20">
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url('https://readdy.ai/api/search-image?query=vintage%20tailwheel%20aircraft%20on%20grass%20runway%20at%20small%20airfield%2C%20classic%20aviation%20training%20scene%20with%20clear%20blue%20sky%2C%20professional%20flight%20training%20environment%2C%20warm%20natural%20lighting%2C%20high%20quality%20aviation%20photography&width=1200&height=600&seq=tailwheel-hero&orientation=landscape')`,
            }}
          >
            <div className="absolute inset-0 bg-black/40"></div>
          </div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl">
              <h1 className="text-5xl font-bold mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
                Tailwheel Endorsement
              </h1>
              <p className="text-xl mb-8 leading-relaxed">
                Get back to basics and learn the skills every pilot should master! Master the art of <strong>tailwheel flying central texas</strong> with professional instruction.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="tel:706-936-8961" 
                  className="bg-white text-teal-600 px-8 py-3 rounded-md text-lg font-semibold hover-bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-block text-center"
                >
                  Call: 706-936-8961
                </a>
                <a 
                  href="tel:512-658-3132" 
                  className="border-2 border-white text-white px-8 py-3 rounded-md text-lg font-semibold hover-bg-white hover-text-teal-600 transition-colors whitespace-nowrap cursor-pointer inline-block text-center"
                >
                  Scott: 512-658-3132
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Course Overview */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
                  Master Traditional Flying Skills
                </h2>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                  Many pilots go their entire flying career having never flown a tailwheel airplane or flown from a grass runway. When you have earned your <strong>tailwheel endorsement</strong>, you will be better prepared to fly any aircraft you may encounter.
                </p>
                <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                  Learning to fly tailwheel aircraft in the relaxed environment here at Stiletto Airpark is as easy and cost-effective as it gets! Our experienced instructors will guide you through every aspect of conventional gear flying.
                </p>
                
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-check-line text-teal-600 text-xl"></i>
                    </div>
                    <span className="ml-3 text-gray-700">Enhanced rudder control and coordination</span>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-check-line text-teal-600 text-xl"></i>
                    </div>
                    <span className="ml-3 text-gray-700">Grass runway operations experience</span>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-check-line text-teal-600 text-xl"></i>
                    </div>
                    <span className="ml-3 text-gray-700">Traditional aviation skills and techniques</span>
                  </div>
                  <div className="flex items-start">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-check-line text-teal-600 text-xl"></i>
                    </div>
                    <span className="ml-3 text-gray-700">Crosswind landing proficiency</span>
                  </div>
                </div>
              </div>
              
              <div className="relative">
                <img 
                  src="https://readdy.ai/api/search-image?query=tailwheel%20aircraft%20cockpit%20interior%20view%20during%20flight%20training%2C%20vintage%20aviation%20instruments%20and%20controls%2C%20professional%20pilot%20instruction%20scene%2C%20warm%20natural%20lighting%2C%20detailed%20aircraft%20interior%20photography&width=600&height=400&seq=tailwheel-cockpit&orientation=landscape"
                  alt="Tailwheel aircraft cockpit during flight training in Central Texas"
                  className="rounded-lg shadow-lg object-cover w-full h-96"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Training Details */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Barlow, sans-serif' }}>
                Training Program Details
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Our comprehensive <strong>flight training </strong> program covers all aspects of tailwheel operations
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-lg shadow-md p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
                  <i className="ri-flight-takeoff-line text-teal-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Ground School</h3>
                <p className="text-gray-600">
                  Comprehensive ground instruction covering tailwheel aerodynamics, ground handling, and safety procedures.
                </p>
              </div>

              <div className="bg-white rounded-lg shadow-md p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
                  <i className="ri-steering-2-line text-teal-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Taxi Training</h3>
                <p className="text-gray-600">
                  Master ground operations, including straight-line taxi, turns, and crosswind taxi techniques.
                </p>
              </div>

              <div className="bg-white rounded-lg shadow-md p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4">
                  <i className="ri-flight-land-line text-teal-600 text-2xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">Flight Training</h3>
                <p className="text-gray-600">
                  Hands-on flight instruction focusing on takeoffs, landings, and emergency procedures in tailwheel aircraft.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Aircraft & Facilities */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/d0668106bc926dd2e77bf53b05b8da4f/c67610963929dbd2535944a2bbd933d0.jpeg"
                  alt="Cessna tailwheel training aircraft at Stiletto Airpark in Bertram Texas"
                  className="rounded-lg shadow-lg object-cover w-full h-96"
                />
              </div>
              
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
                  Our Training Aircraft
                </h2>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                  Train in our well-maintained Cessna tailwheel aircraft, perfect for learning conventional gear operations. Our fleet is specifically chosen for <strong>tailwheel endorsement</strong> training programs.
                </p>
                
                <div className="space-y-6">
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Cessna Taildraggers</h3>
                    <p className="text-gray-700">Classic training aircraft with forgiving flight characteristics and excellent visibility.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Grass Runway Operations</h3>
                    <p className="text-gray-700">Experience authentic grass runway flying at our private airpark facility.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">Professional Maintenance</h3>
                    <p className="text-gray-700">All aircraft maintained to the highest standards for safe, reliable training.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Pricing Section */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Barlow, sans-serif' }}>
                Course Pricing
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Comprehensive training package designed to exceed insurance requirements
              </p>
            </div>

            <div className="max-w-lg mx-auto">
              <div className="bg-white rounded-2xl shadow-xl border-2 border-teal-100 overflow-hidden">
                <div className="bg-teal-600 text-white text-center py-6">
                  <h3 className="text-2xl font-bold mb-2" style={{ fontFamily: 'Barlow, sans-serif' }}>
                    Tailwheel Course
                  </h3>
                  <div className="text-4xl font-bold">$2,500.00</div>
                </div>
                
                <div className="p-8">
                  <div className="text-center mb-6">
                    <p className="text-lg text-gray-700 font-semibold mb-2">
                      Includes 10 hrs of flight time with CFI and ground instruction
                    </p>
                    <p className="text-sm text-teal-600 font-medium">
                      (Exceeds Insurance Minimums)
                    </p>
                  </div>
                  
                  <div className="space-y-4 mb-8">
                    <div className="flex items-start">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className="ri-check-line text-teal-600 text-xl"></i>
                      </div>
                      <span className="ml-3 text-gray-700">10 hours of dual flight instruction</span>
                    </div>
                    <div className="flex items-start">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className="ri-check-line text-teal-600 text-xl"></i>
                      </div>
                      <span className="ml-3 text-gray-700">Comprehensive ground instruction</span>
                    </div>
                    <div className="flex items-start">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className="ri-check-line text-teal-600 text-xl"></i>
                      </div>
                      <span className="ml-3 text-gray-700">Check out in multiple different taildraggers</span>
                    </div>
                    <div className="flex items-start">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className="ri-check-line text-teal-600 text-xl"></i>
                      </div>
                      <span className="ml-3 text-gray-700">Expanded experience across aircraft types</span>
                    </div>
                  </div>
                  
                  <div className="text-center">
                    <a 
                      href="tel:706-936-8961" 
                      className="bg-teal-600 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer inline-block"
                    >
                      Book Your Course
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="py-16 bg-teal-600 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold mb-6" style={{ fontFamily: 'Barlow, sans-serif' }}>
              Ready to Master Tailwheel Flying?
            </h2>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              Join the ranks of skilled pilots who have mastered conventional gear aircraft. Start your <strong>tailwheel endorsement central texas</strong> training today!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:706-936-8961" 
                className="bg-white text-teal-600 px-8 py-3 rounded-md text-lg font-semibold hover-bg-gray-100 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                Call Bryson: 706-936-8961
              </a>
              <a 
                href="tel:512-658-3132" 
                className="border-2 border-white text-white px-8 py-3 rounded-md text-lg font-semibold hover-bg-white hover-text-teal-600 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                Call Scott: 512-658-3132
              </a>
            </div>
            
            <div className="mt-8">
              <Link 
                to="/" 
                className="text-teal-200 hover:text-white transition-colors"
              >
                ← Back to Home
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
